var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ElementRef, Renderer2, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CookieReader } from '../storage/cookie-reader';
import { StorageKeys } from '../enums/storage-keys';
var DisplayStandardDirective = /** @class */ (function () {
    function DisplayStandardDirective(el, router, renderer, cookieReader) {
        this.el = el;
        this.router = router;
        this.renderer = renderer;
        this.cookieReader = cookieReader;
        this.routerSubscription = new Subscription();
    }
    DisplayStandardDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function () {
            if (_this.cookieReader.getCookie(StorageKeys.EportfolioUser))
                _this.renderer.removeClass(_this.el.nativeElement, 'd-none');
            else
                _this.renderer.addClass(_this.el.nativeElement, 'd-none');
        });
    };
    DisplayStandardDirective.prototype.ngOnDestroy = function () {
        this.routerSubscription.unsubscribe();
    };
    DisplayStandardDirective = __decorate([
        Directive({
            selector: '[dirDisplayStandards]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Router,
            Renderer2,
            CookieReader])
    ], DisplayStandardDirective);
    return DisplayStandardDirective;
}());
export { DisplayStandardDirective };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzcGxheS1zdGFuZGFyZHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJkaXNwbGF5LXN0YW5kYXJkcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQXFCLE1BQU0sZUFBZSxDQUFDO0FBQ3BGLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUN6QyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sTUFBTSxDQUFDO0FBRXBDLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSwwQkFBMEIsQ0FBQztBQUN4RCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sdUJBQXVCLENBQUM7QUFLcEQ7SUFDSSxrQ0FBMkIsRUFBYyxFQUNwQixNQUFjLEVBQ2QsUUFBbUIsRUFDbkIsWUFBMEI7UUFIcEIsT0FBRSxHQUFGLEVBQUUsQ0FBWTtRQUNwQixXQUFNLEdBQU4sTUFBTSxDQUFRO1FBQ2QsYUFBUSxHQUFSLFFBQVEsQ0FBVztRQUNuQixpQkFBWSxHQUFaLFlBQVksQ0FBYztRQUV2Qyx1QkFBa0IsR0FBaUIsSUFBSSxZQUFZLEVBQUUsQ0FBQztJQUZYLENBQUM7SUFJN0MsMkNBQVEsR0FBZjtRQUFBLGlCQU9DO1FBTkcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDO1lBQ3pCLElBQUksS0FBSSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLGNBQWMsQ0FBQztnQkFDdkQsS0FBSSxDQUFDLFFBQVEsQ0FBQyxXQUFXLENBQUMsS0FBSSxDQUFDLEVBQUUsQ0FBQyxhQUFhLEVBQUUsUUFBUSxDQUFDLENBQUM7O2dCQUUzRCxLQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxLQUFJLENBQUMsRUFBRSxDQUFDLGFBQWEsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUNoRSxDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7SUFFTSw4Q0FBVyxHQUFsQjtRQUNJLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUMxQyxDQUFDO0lBbkJRLHdCQUF3QjtRQUhwQyxTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsdUJBQXVCO1NBQ3BDLENBQUM7eUNBRWlDLFVBQVU7WUFDWixNQUFNO1lBQ0osU0FBUztZQUNMLFlBQVk7T0FKdEMsd0JBQXdCLENBb0JwQztJQUFELCtCQUFDO0NBQUEsQUFwQkQsSUFvQkM7U0FwQlksd0JBQXdCIn0=